import createIcon from './createIcon';

export default createIcon(require('./whatsapp.svg'));